<template lang="html">
  <div>
    <div v-if="is_finish" class="time-line" v-for="i in list" :key="i.id">
      <div class="first">
        <img :src="$store.state.static_img_url+'mobile/pic/theme/timeline.png'">
        <div class="empty-area"></div>
        <div>
          <p class="title" v-if="i.display_title == '1'">{{i.title}}</p>
          <p class="summary" v-html="i.summary"></p>
        </div>
      </div>
      <div class="line" :class="{'line-format':i.time_format == '1' || i.time_format == '2' || i.time_format == '3', 'line-no':i.display_title == '0' && (i.summary == '' || i.summary == null)}">
        <!-- 0 年1 年月2 年月日3 年月日分时秒 -->
        <!-- 年 -->
        <ul class="time-format0" v-if="i.time_format == '0'">
          <li v-for="j in deal_all['list_index'+i.id].list" :key="j[0]">
            <img :src="$store.state.static_img_url+'mobile/pic/theme/jiedian.png'">
            <div class="time"> <span>{{j[0]}}</span> </div>
            <div class="content" v-for="m in j[1]" :key="m.id">
              <p v-html="m.title"></p>
              <p v-html="m.content_unsigned" v-if="i.display_topic_content == '1'"></p>
            </div>
          </li>
        </ul>
        <!-- 年月， 年月日 -->
        <div v-if="i.time_format == '1' || i.time_format == '2'">
          <ul class="time-format12" v-for="j in deal_all['list_index'+i.id]['list']">
            <li v-for="m in j[1]" :key="m[0]">
              <img :src="$store.state.static_img_url+'mobile/pic/theme/jiedian.png'">
              <p class="time"> <span>{{m[0]}}</span> <span>{{j[0]}}</span> </p>
              <div class="content" v-for="n in m[1]" :key="n.id">
                <p v-html="n.title"></p>
                <p v-html="n.content_unsigned" v-if="i.display_topic_content == '1'"></p>
              </div>
            </li>
          </ul>
        </div>
        <!-- 年月日分时秒 -->
        <div v-if="i.time_format == '3'">
          <ul class="time-format3" v-for="j in deal_all['list_index'+i.id]['list']">
            <li v-for="(m, index) in j[1]" :key="m[0]">
              <img :src="$store.state.static_img_url+'mobile/pic/theme/jiedian.png'">
              <p class="time"><span>{{dealTime(m[0], 1)}}</span>  <span>{{dealTime(m[0], 0)}}</span> </p>
              <div class="time-content" v-for="(n, index) in m[1]" :key="n.id">
                <div class="content">
                  <p v-html="n.title"></p>
                  <p v-html="n.content_unsigned" v-if="i.display_topic_content == '1'"></p>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="share">
          <span>分享至</span>
          <div @click="goShare(i.id)">
            <i class="iconfont">&#xe641;</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filter from 'mobile/js/filter'
export default {
  data() {
    return {
      is_finish: false,
      deal_all: {}
    }
  },
  props: ['list'],
  methods: {
    dealList() {
      for(let i of this.list) {
        let map = new Map()
        let temp = []
        this.deal_all['list_index'+i.id] = {}
        this.deal_all['list_index'+i.id]['time_format'] = i.time_format
        switch (i.time_format) {
          case '0': {// 年
            for(let j of i.line_content) {
              let year = filter.time_moment(j.oldest_news_publish_time, 'YYYY') + '年'
              if (map.has(year)) {
                map.get(year).push(j)
              } else {
                map.set(year, [j])
              }
            }
            // list的数据机构(二维数组)
            // ['2019年',['item','item']]
            this.deal_all['list_index'+i.id]['list'] = [...map]
            break;
          }
          case '1': // 年月
          case '2': // 年月日
          case '3': {// 年月日时分秒
            for(let j of i.line_content) {
              let year = filter.time_moment(j.oldest_news_publish_time, 'YYYY') + '年'
              let month
              if (i.time_format == '1') {
                month = filter.time_moment(j.oldest_news_publish_time, 'MM') + '月'
              } else if(i.time_format == '2'){
                month = filter.time_moment(j.oldest_news_publish_time, 'MM-DD')
              } else {
                month = filter.time_moment(j.oldest_news_publish_time, 'MM-DD') + ' ' + filter.time_standard_temp(j.oldest_news_publish_time, 'HH:mm')
              }
              if (map.has(year)) { // 先给年分类
                if (map.get(year).has(month)) {
                  map.get(year).get(month).push(j)
                } else {
                  map.get(year).set(month, [j])
                }
              } else {
                map.set(year, new Map())
                map.get(year).set(month, [j])
              }
            }
            let list = [...map]
            for (let m of list) {
              m[1] = [...m[1]]
            }
            // list的数据机构(三维数组)
            // ['2019',map]
            // ['2019',['12月',[item, item]]]
            this.deal_all['list_index'+i.id]['list'] = list
            break;
          }
        }
      }
      this.is_finish = true
    },
    dealTime(time, index) {
      return time.split(' ')[index]
    },
    goShare(time_line_id) {
      this.$router.push({name: 'MShareTimeLine', query: {theme_uid: this.$route.params.uid || this.$route.query.theme_uid, time_line_id: time_line_id}})
    }
  },
  mounted() {
    this.dealList()
  }
}
</script>

<style lang="stylus" scoped>
.time-line
  margin-top: .4rem;
  margin-left: .24rem
  padding-left: .4rem;
  padding-bottom: .68rem;
  border-left: 1px dashed #E9E9E9
  .first
    position: relative;
    .empty-area
      width: .38rem;
      height: .3rem;
      position: absolute;
      left: -.6rem;
      top: 0;
      background: #FFFFFF;
      padding: 0;
    >img
      width: .38rem;
      height: .38rem;
      position: absolute;
      left: -.6rem;
      top: .3rem;
    >div
      padding: .3rem .4rem;
      background: #FFFAF6;
      p.title
        font-size: .32rem;
        color: #333333;
        font-weight: bold;
        line-height: .45rem;
      p.summary
        color: #666666;
        font-size: .28rem;
        line-height: .48rem;
        margin-top: .1rem;
  .line
    // margin-top: .5rem;
    .time-format3, .time-format12, .time-format0
      li
        position: relative;
        margin-top: .5rem;
        >img
          width: .44rem;
          height: .44rem;
          position: absolute;
          left: -.62rem;
          top: -.06rem;
        .time
          font-size: .24rem;
          color: #999999;
          line-height: .32rem;
          span:nth-child(1)
            color: #FF8824
            margin-right: .12rem;
        .content
          font-size: .28rem;
          p:nth-child(1)
            color: #333333;
            font-weight: .28rem;
            line-height: .44rem;
            font-weight: bold;
            margin-top: .14rem;
          p:nth-child(2)
            color: #666666;
            line-height: .48rem;
            margin-top: .08rem;
    .share
      float: right;
      display: flex;
      align-items: center;
      span
        font-size: .24rem;
        color: #999999;
      div
        width: .68rem;
        height: .68rem;
        text-align: center;
        line-height: .68rem;
        margin-left: .2rem;
        display: inline-block;
        background: #fff;
        border-radius: 50%;
        border: 1px #eee solid;
        i
          color: rgb(46, 198, 107);
          font-size: .40rem;
</style>
